import { AnalysisType } from "../../types/analysis";
import { DashboardEventType, logDashboardEvent } from "../../utils/logger";
import {
    LogParams,
    SdCreatedParams,
    logDashboardEventAction,
    startNewClassSession,
    setCurrentCompetencyId,
    generateExampleFromEventId,
    GenerateExamplePayload
} from "../actions/statistics";
import { setCardType } from "../actions/teacher-ui-actions";
import { Handler, createClientMiddleware } from "./types";


const onSdCreated: Handler<SdCreatedParams> = () => {
    logDashboardEvent({ type: DashboardEventType.startDashboardForClass });
};

const onSetCardType: Handler<AnalysisType> = ({ payload }) => {
    logDashboardEvent({ type: DashboardEventType.changeReportCardType, data: { type: payload }});
};

const onSetCompetency: Handler<string> = ({ payload }) => {
    logDashboardEvent({ type: DashboardEventType.changeSkill, data: {skillId: payload} });
};

const onGenerateExample: Handler<GenerateExamplePayload> = ({ payload }) => {
    logDashboardEvent({ type: DashboardEventType.openExampleProblem });
};

const onLogDashboardEvent: Handler<LogParams> = ({ payload }) => {
    logDashboardEvent(payload);
};

/**
 * These are for handlers coming from the game iframe back into the client
 */
export const createLoggingDashboardMiddleware = createClientMiddleware(() => void 0)
    .on(startNewClassSession, onSdCreated)
    .on(setCardType, onSetCardType)
    .on(setCurrentCompetencyId, onSetCompetency)
    .on(generateExampleFromEventId, onGenerateExample)
    .on(logDashboardEventAction, onLogDashboardEvent)
    .build();